import { gql } from '@apollo/client'

import {
  PAYMENT_METHODS_FRAGMENT,
  PAYMENT_METHODS_FRAGMENT_STRING
} from '../fragments/paymentMethodFragments'

const CREATE_PAYMENT_METHOD_MUTATION_STRING = `
  ${PAYMENT_METHODS_FRAGMENT_STRING}
  mutation CreatePaymentMethodMutation(
    $userId: ID!,
    $archivedType: ArchivedType,
    $paymentMethods: [PaymentMethodInput!]!
  ) {
    paymentMethodsCreate(
      userId: $userId,
      paymentMethods: $paymentMethods
    ) {
      ...PaymentMethodsFragment
    }
  }
`

const CREATE_PAYMENT_METHOD_MUTATION = gql`
  ${PAYMENT_METHODS_FRAGMENT}
  mutation CreatePaymentMethodMutation(
    $userId: ID!
    $archivedType: ArchivedType
    $paymentMethods: [PaymentMethodInput!]!
  ) {
    paymentMethodsCreate(userId: $userId, paymentMethods: $paymentMethods) {
      ...PaymentMethodsFragment
    }
  }
`

export { CREATE_PAYMENT_METHOD_MUTATION, CREATE_PAYMENT_METHOD_MUTATION_STRING }
